var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.multi
    ? _c("w-select", {
        attrs: {
          fancy: _vm.fancy,
          items: _vm.items,
          label: _vm.label,
          value: _vm.value,
        },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _c("w-multi-select", {
        attrs: {
          fancy: _vm.fancy,
          items: _vm.items,
          label: _vm.label,
          value: _vm.value,
          "empty-text": "Geen gekozen",
        },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }